export enum InviteContactMethod {
  Email = 'email',
  MobilePhoneNumber = 'mobile-phone-number',
}
